export default "__VITE_ASSET__832c938b__"